import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { DemandasMonitoramento } from "../models/demandas-monitoramento.model";

@Injectable()
export class DemandasMonitoramentoService extends BaseService<DemandasMonitoramento>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/demandas-monitoramento';
  }

  public listAndamento(): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-andamento", { headers: this.headers });
  }

  public listSituacao(): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-situacao", { headers: this.headers });
  }

  public listSituacao2(): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/list-situacao2", { headers: this.headers });
  }

  public sendMail(id: number): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/enviar-email/" + id, { headers: this.headers });
  }

  public createMessage(id: number, obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + `/${id}/message`, obj, { headers: this.headers });
  }

  public transferir(id: number, obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "/transferir/" + id, obj, { headers: this.headers });
  }

  public concluir(id: number, obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "/concluir/" + id, obj, { headers: this.headers });
  }

  public entregaList(id: number): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/entrega-list/" + id, { headers: this.headers });
  }

  public indicadorList(id: number): Observable<any> | any {
    return this.http.get<any>(this.baseUrl + "/indicador-list/" + id, { headers: this.headers });
  }

  public preDemanda(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "/pre-demanda", obj, { headers: this.headers });
  }

  // public sendMail(id: number): Observable<any> | any {
  //   var dados = {
  //     issue_id_mail1: id
  //  };
  //   return this.http.post<any>(this.baseUrl + "/demandas/ajax_update.php", { headers: this.headers });
  // }
}
